import React from 'react';
import { translate } from '../../utils/translations';
import PropTypes from 'prop-types';
import { dts } from '../../img';
import { links } from '../../utils/urls';

const {
    baseMeteo,
    baseGencat,
    footerAccessibilitat,
    footerAvisLegal,
    footerContacte,
    footerSobreGencat,
    footerSobreMeteo,
} = links;

const Footer = props => (
    <div className="configurador__footer">
        <div className="configurador__footer-top" />
        <div className="configurador__footer-main">
            <span>
                <a href={`${baseMeteo}${footerAvisLegal}`}>
                    {translate(props.language, 'footer_legal')}
                </a>
                |
                <a href={`${baseGencat}${footerAccessibilitat}`}>
                    {translate(props.language, 'footer_accessibility')}
                </a>
                |
                <a href={`${baseMeteo}${footerContacte}`}>
                    {translate(props.language, 'footer_contact')}
                </a>
                |
                <a href={`${baseMeteo}${footerSobreMeteo}`}>
                    {translate(props.language, 'footer_about_meteocat')}
                </a>
                |
                <a href={`${baseGencat}${footerSobreGencat}`}>
                    {translate(props.language, 'footer_about_gencat')}
                </a>
            </span>
            <div>
                <a href={baseGencat}>
                    <img src={dts} alt="Generalitat de Catalunya" />
                </a>
            </div>
        </div>
        <div className="configurador__footer-bottom" />
    </div>
);

Footer.propTypes = {
    language: PropTypes.string,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/Configurador/Footer.js